module.exports = __webpack_public_path__ + "static/media/sub_product_icon.732bcf62.svg";